import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import template from '../../../templates/PageLayout/Popups/AssignCategoryImagePopup.rt';
import { toggleFeatureGroupImagePopup, setNewFeatureGroupImage } from "../../../components/NewScope/newScopeActions";
import PS from "../../ProjectScope/ProjectScopeActionsNew";
import {ProjectScopeIcons} from "../../ProjectScope/NewFeatureGroup";
import {getIconStyles} from "../../../utilities/iconSizes";

class AssignFeatureGroupImagePopup extends React.Component {

  static propTypes = {
    activeImageEditFeatureGroup: PropTypes.object, // feature group
    updateFeatureGroup: PropTypes.func,
    setNewFeatureGroupImage: PropTypes.func
  };

  state = {
    headerText: "Image gallery"
  };

  isSelectedImage = (image) => {
    const featureGroupImage = this.props.activeImageEditFeatureGroup.image
      || this.props.activeImageEditFeatureGroup.customImageUrl;
    return featureGroupImage === image
  };

  isLastImage = (imageIndex) => {
    const allItemsLength = ProjectScopeIcons.length;
    return imageIndex >= allItemsLength - (allItemsLength % 7); // should be imageIndex > 82 - 5 // 5 is rest after divide
  };

  getImageStyle = (image) => {
    return getIconStyles(image);
  };

  handleClose = () => {
    this.props.toggleFeatureGroupImagePopup(null);
  };

  selectCategoryImage = (image) => {
    if (this.props.activeImageEditFeatureGroup.newFeatureGroup) {
      this.props.setNewFeatureGroupImage(image)
    } else {
      const updatedFeatureGroup = this.props.activeImageEditFeatureGroup;
      updatedFeatureGroup["customImageUrl"] = image;
      this.props.updateFeatureGroup(updatedFeatureGroup);
    }
    this.props.toggleFeatureGroupImagePopup(null);
  };

  render() {
    return template.call(this)
  }
}

const mapStateToProps = (store) => {
  return {
    activeImageEditFeatureGroup: store.newScope.activeImageEditFeatureGroup,
  };
};

export default connect(mapStateToProps, {
  updateFeatureGroup: (featureGroup) => PS.updateFeatureGroup(featureGroup),
  toggleFeatureGroupImagePopup,
  setNewFeatureGroupImage
})(AssignFeatureGroupImagePopup);
